<template>
  <div>
    <!-- 撤回：使用步骤条展示 -->
    <el-steps
      v-if="apply && apply.status === '4'"
      :active="currentRate"
      align-center
      finish-status="success"
    >
      <el-step
        :title="apply.sponsorAccountName + '已撤回'"
        :description="sponsorDate"
      ></el-step>
    </el-steps>

    <!-- 正常审批：按级别分组展示 -->
    <div v-else class="dialog_content">
      <div class="dialog_content_item">
        <div class="dialog_content_item_title">发起审批</div>
        <div class="dialog_content_item_text">
          <ul>
            <li class="dialog_content_item_text_account">
              {{ sponsorName }} 发起审批
            </li>
            <li class="dialog_content_item_text_time">
              {{ sponsorDate }}
            </li>
          </ul>
        </div>
      </div>

      <div
        class="dialog_content_item"
        v-if="level1List.length > 0"
      >
        <div class="dialog_content_item_title" :class="isLeveled1">
          一级审批<span v-if="level1Text">（{{ level1Text }}）</span>
        </div>
        <div class="dialog_content_item_text">
          <ul v-for="item in level1List" :key="item.code">
            <li
              class="dialog_content_item_text_account"
              :style="{ color: item.fontColor }"
            >
              {{ item.approveAccountName || item.accountName }} {{ item.statusText }}
            </li>
            <li class="dialog_content_item_text_time">
              {{ item.approveDate }}
            </li>
          </ul>
        </div>
      </div>

      <div
        class="dialog_content_item"
        v-if="level2List.length > 0"
      >
        <div class="dialog_content_item_title" :class="isLeveled2">
          二级审批<span v-if="level2Text">（{{ level2Text }}）</span>
        </div>
        <div class="dialog_content_item_text">
          <ul v-for="item in level2List" :key="item.code">
            <li
              class="dialog_content_item_text_account"
              :style="{ color: item.fontColor }"
            >
              {{ item.approveAccountName || item.accountName }} {{ item.statusText }}
            </li>
            <li class="dialog_content_item_text_time">
              {{ item.approveDate }}
            </li>
          </ul>
        </div>
      </div>

      <div
        class="dialog_content_item"
        v-if="level3List.length > 0"
      >
        <div class="dialog_content_item_title" :class="isLeveled3">
          三级审批<span v-if="level3Text">（{{ level3Text }}）</span>
        </div>
        <div class="dialog_content_item_text">
          <ul v-for="item in level3List" :key="item.code">
            <li
              class="dialog_content_item_text_account"
              :style="{ color: item.fontColor }"
            >
              {{ item.approveAccountName || item.accountName }} {{ item.statusText }}
            </li>
            <li class="dialog_content_item_text_time">
              {{ item.approveDate }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'approvalFlowDialog',
  props: {
    // 发起人/状态信息
    apply: {
      type: Object,
      default: () => ({}),
    },
    // 后端返回的审批链（各业务字段可能不同，组件内部统一规范化）
    chain: {
      type: Array,
      default: () => [],
    },
    // 审批流程明细（flow.flowDetails），用于补充审批人名称
    flow: {
      type: Array,
      default: () => [],
    },
    // status 字段的取值约定：'three'=2通过/3驳回（水/电/账单）；'two'=1通过/2驳回（免费码）
    statusMode: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      currentRate: 0,
      level1List: [],
      level2List: [],
      level3List: [],
      level1Text: '',
      level2Text: '',
      level3Text: '',
      isLeveled1: '',
      isLeveled2: '',
      isLeveled3: '',
    }
  },
  computed: {
    sponsorName() {
      return (
        this.apply.sponsorAccountName || this.apply.personName || this.apply.accountName || ''
      )
    },
    sponsorDate() {
      return (
        this.apply.sponsorDate || this.apply.createTime || this.apply.applyDate || ''
      )
    },
  },
  watch: {
    chain: {
      handler() {
        this.buildFlow()
      },
      deep: true,
      immediate: true,
    },
    flow: {
      handler() {
        this.buildFlow()
      },
      deep: true,
      immediate: true,
    },
    apply: {
      handler() {
        this.buildFlow()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    buildFlow() {
      const chain = this.normalizeChain(this.chain || [])
      if (!chain.length) {
        this.currentRate = 0
        this.level1List = []
        this.level2List = []
        this.level3List = []
        this.resetLeveled()
        return
      }
      // 撤回状态时只展示步骤条
      if (this.apply && this.apply.status === '4') {
        this.currentRate = 0
        this.level1List = []
        this.level2List = []
        this.level3List = []
        this.resetLeveled()
        return
      }
      const arr1 = chain.filter((item) => Number(item.level) === 1)
      const arr2 = chain.filter((item) => Number(item.level) === 2)
      const arr3 = chain.filter((item) => Number(item.level) === 3)
      const levelArr1 = this.getNewChainList(arr1)
      const levelArr2 = this.getNewChainList(arr2)
      const levelArr3 = this.getNewChainList(arr3)
      this.level1List = levelArr1
      this.level2List = levelArr2
      this.level3List = levelArr3
      this.isLeveled1 = this.getLeveledStatus(levelArr1)
      this.isLeveled2 = this.getLeveledStatus(levelArr2)
      this.isLeveled3 = this.getLeveledStatus(levelArr3)
      this.level1Text = this.getLevelModeText(arr1)
      this.level2Text = this.getLevelModeText(arr2)
      this.level3Text = this.getLevelModeText(arr3)
      // 当前进度（用于撤回步骤条 / 兼容展示）
      this.currentRate = this.getCurrentRate()
    },

    // 把后端原始审批链统一为展示结构
    normalizeChain(list) {
      if (!list || !list.length) return []
      const out = []
      list.forEach((v) => {
        // 节点内含多人（flowNodePersons）时，拆分为每个审批人一条
        if (v.flowNodePersons && v.flowNodePersons.length) {
          const persons = this.expandPersons(v)
          out.push(...persons)
          return
        }
        out.push(this.normalizeItem(v))
      })
      return out
    },

    normalizeItem(v) {
      const accountCode = v.approveAccountCode || v.accountCode || ''
      const flowNode = this.findFlowNode(accountCode, v.accountCode)
      const accountName =
        v.approveAccountName ||
        v.accountName ||
        v.personName ||
        (flowNode && flowNode.accountName) ||
        ''
      const level = v.level != null ? v.level : v.index != null ? v.index : 0
      return {
        code: v.code || '',
        level: Number(level),
        approveAccountCode: accountCode,
        approveAccountName: accountName,
        approveDate: v.approveDate || '',
        // resultStatus: 3=通过 2=拒绝 其余未审批
        resultStatus: this.convertResultStatus(v),
        approvalMode: v.approvalMode || '',
        approveStatus: v.approveStatus,
        invoked: v.invoked,
        isPerhaps: v.isPerhaps,
      }
    },

    // 根据 accountCode 在流程明细里查找审批人名称
    findFlowNode(accountCode, fallbackCode) {
      const list = this.flow || []
      return list.find(
        (f) =>
          (f.accountCode && f.accountCode === accountCode) ||
          (fallbackCode && f.accountCode === fallbackCode),
      )
    },

    // 兼容多人节点（flowNodePersons）平铺到审批链
    expandPersons(v) {
      const persons = v.flowNodePersons || []
      if (!persons.length) return [v]
      const level = v.level != null ? v.level : v.idx || v.index
      return persons.map((p) => {
        const merged = Object.assign({}, this.normalizeItem(v), p)
        merged.level = level
        merged.approveAccountCode = p.accountCode || merged.approveAccountCode || ''
        merged.approveAccountName = p.personName || p.accountName || merged.approveAccountName || ''
        return merged
      })
    },

    // 各业务模块状态字段不同，统一映射为 resultStatus
    convertResultStatus(v) {
      if (v.resultStatus != null && v.resultStatus !== '') {
        return String(v.resultStatus)
      }
      // 合同/车位等该字段缺失时按 approveResult 派生
      if (v.approveResult) {
        if (v.approveResult === '通过') return '3'
        if (v.approveResult === '驳回') return '2'
        if (String(v.approveResult) === '1') return '3'
        if (String(v.approveResult) === '2') return '2'
      }
      if (v.status) {
        const s = String(v.status)
        if (this.statusMode === 'two') {
          // 免费码: 1=通过 2=驳回
          if (s === '1') return '3'
          if (s === '2') return '2'
        } else {
          // 默认（水/电/账单）: 2=通过 3=驳回
          if (s === '2') return '3'
          if (s === '3') return '2'
        }
      }
      return '0'
    },

    // 计算某一级的状态样式：已通过 / 已拒绝 / 未审批
    getLeveledStatus(list) {
      if (!list || !list.length) return ''
      const statuses = list.map((v) => v.resultStatus)
      // 存在拒绝则整级为拒绝
      if (statuses.indexOf('2') > -1) return 'dialog_content_item_title_reject'
      // 会签：全部通过才为通过；或签：任意一个通过即为通过
      const isCountersign = list[0].approvalMode === '1' && list.length > 1
      if (isCountersign) {
        if (statuses.indexOf('3') > -1 && statuses.indexOf('1') < 0 && statuses.indexOf('0') < 0) {
          return 'dialog_content_item_title_pass'
        }
      } else {
        if (statuses.indexOf('3') > -1) return 'dialog_content_item_title_pass'
      }
      return 'dialog_content_item_title_unapprove'
    },

    // 计算某一级的审批方式文字：会签 / 或签
    getLevelModeText(list) {
      if (!list || list.length < 2) return ''
      const mode = list[0] && list[0].approvalMode
      if (mode === '1') return '会签'
      if (mode === '2') return '或签'
      return ''
    },

    // 计算当前步骤条进度（撤回时使用）
    getCurrentRate() {
      let rate = 0
      const after = (item) => {
        if (item.invoked && item.approveStatus == 1) {
          rate++
        }
      }
      ;[this.level1List, this.level2List, this.level3List].forEach((group) =>
        group.forEach(after),
      )
      return rate
    },

    // 对某一级的审批链做排列表
    getNewChainList(arr) {
      let levelArr = []
      let arr1 = []
      let arr2 = []
      let arr3 = []
      if (arr.length > 0) {
        let isPerhaps = false
        arr.map((v) => {
          if ((v.approvalMode === '2') & (v.resultStatus === '3')) {
            isPerhaps = true
          }
          if (v.resultStatus === '3') {
            v.statusText = '已通过'
            v.fontColor = '#3CC0A7'
            arr1.push(v)
          } else if (v.resultStatus === '2') {
            v.statusText = '已拒绝'
            v.fontColor = '#B10000'
            arr2.push(v)
          } else {
            v.statusText = '未审批'
            v.fontColor = '#3C44C0'
            arr3.push(v)
          }
        })
        levelArr = [...arr1, ...arr2, ...arr3]
        if (isPerhaps) {
          levelArr.map((item) => {
            item.isPerhaps = true
          })
        }
      }
      return levelArr
    },

    resetLeveled() {
      this.isLeveled1 = ''
      this.isLeveled2 = ''
      this.isLeveled3 = ''
      this.level1Text = ''
      this.level2Text = ''
      this.level3Text = ''
    },
  },
}
</script>

<style scoped>
.dialog_content {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.dialog_content_item {
  width: 1.1rem;
  font-size: 0.11rem;
  text-align: center;
}
.dialog_content_item:first-child .dialog_content_item_text_account {
  color: rgba(60, 192, 167, 1);
}
.dialog_content_item_title {
  width: 1.1rem;
  height: 0.24rem;
  line-height: 0.26rem;
  color: #fff;
  font-weight: 500;
  background-image: url('../../../assets/approval/start_approve_icon.png');
  background-size: 100% 100%;
  text-align: left;
  padding-left: 0.15rem;
}
.dialog_content_item_title span {
  font-size: 0.08rem;
}
.dialog_content_item_title_pass {
  background-image: url('../../../assets/approval/pass_icon.png');
  background-size: 100% 100%;
}
.dialog_content_item_title_reject {
  background-image: url('../../../assets/approval/reject_icon.png');
  background-size: 100% 100%;
}
.dialog_content_item_title_unapprove {
  background-image: url('../../../assets/approval/unapprove_icon.png');
  background-size: 100% 100%;
}
.dialog_content_item_text_account_pass {
  color: rgba(60, 192, 167, 1);
}
.dialog_content_item_text_reject {
  color: rgba(177, 0, 0, 1);
}
.dialog_content_item_text_unapprove {
  color: rgba(60, 68, 192, 1);
}
.dialog_content_item_text {
  text-align: left;
  font-size: 0.09rem;
  padding-left: 0.15rem;
}
.dialog_content_item_text_account {
  font-weight: 500;
  margin-top: 10px;
}
.dialog_content_item_text_time {
  font-size: 0.07rem;
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/view/PendingItems/components/approvalFlowDialog.vue